export const MAX_TOKEN_REFRESH_RETRY = 5;
export const MAX_HTTP_REQUEST_RETRY = 3;
export const navigationBarColor = '#242C36';
export const statusBarColor = '#4DA47A';
export const NAVBAR_HEIGHT = 55;
export const PENING_MEMEBRS_LENGTH = 9;
